// Compact 4-step wizard progress — mobile-first (dots + current label),
// full labels from sm: up. Steps: Divisões → Equipamento → Cor → Resumo.

const STEPS = ['Divisões', 'Equipamento', 'Cor', 'Resumo'] as const;

export function StepperNav({ current }: { current: 1 | 2 | 3 | 4 }) {
  return (
    <nav aria-label="Progresso" className="flex items-center gap-1.5 px-4 py-2">
      {STEPS.map((label, i) => {
        const step = i + 1;
        const isCurrent = step === current;
        const isDone = step < current;
        return (
          <div key={label} className="flex min-w-0 items-center gap-1.5">
            {i > 0 && <span className="h-px w-3 shrink-0 bg-smartify-line sm:w-5" />}
            <span
              className={[
                'flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold',
                isCurrent
                  ? 'bg-smartify-brand text-white'
                  : isDone
                    ? 'bg-smartify-brand/15 text-smartify-brand'
                    : 'border border-smartify-line bg-white text-smartify-muted',
              ].join(' ')}
              aria-current={isCurrent ? 'step' : undefined}
            >
              {isDone ? '✓' : step}
            </span>
            <span
              className={[
                'truncate text-xs',
                isCurrent ? 'font-semibold text-smartify-ink' : 'hidden text-smartify-muted sm:inline',
              ].join(' ')}
            >
              {label}
            </span>
          </div>
        );
      })}
    </nav>
  );
}
